module.exports = __webpack_public_path__ + "img/alcohol.3dc55622.svg";